/**
 * 全部资源
 * created by yxy
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';

import BaseComponent from "../../../../base/BaseComponent";
import { Modal} from "antd";
import ChoiceType from '../../components/ChoiceType';
import {formatTime,changeSize} from "../../../../utils";
import '../../style/public.css'
import PageTableComponent from "../../components/pageTable/PageTable";
import {AUDIO_TYPE, HEADER_HEIGHT, PIC_TYPE, VIDEO_TYPE} from "../../../../constants";
import $ from "jquery";
const { confirm } = Modal;



export default class Download extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {

        super(props);
        this.state={
            typeList:[],//全部类型
            selectType:[],//选中的类型
            searchText:'',//搜索的文字
            backList:[],//返回列表
            startTime:'',//开始时间
            endTime:'',//结束时间
            page:1,
            size:10,
            data:[],

        }
    }

    componentWillMount() {

    }
    componentDidMount() {
        this.getRefreshList()
    }
    render() {

        return (
            <div style={{background: '#ffffff',
                padding: '24px 32px 16px 32px',
                margin: "15px 0 15px 15px",
                position: 'relative',
                borderRadius:5
            }}>
                {/*渲染选择框以及下载 功能*/}
                {this.renderBtn()}
                {/*渲染数据*/}
                {this.renderData()}
            </div>
        )
    }

    renderBtn(){
        return(
            <div style={{lineHeight:'32px'}}> <ChoiceType  RangePickerShow={false}
                               allDelete={()=>{
                                   this.allDelete()
                               }}
                               refresh={()=>{
                                   this.getRefreshList()
                               }}
                               onSaveCallback={(searchText,selectType,startTime,endTime)=>{
                                   this.setState({searchText:searchText,selectType:selectType,startTime:startTime,endTime:endTime,page:1},()=>{
                                       this.getList()
                                   })
                               }}></ChoiceType></div>

        )
    }
    renderData(){
        let  columns=[
            {
                title: '名称',
                dataIndex: 'name',
                width:600,
                ellipsis: true,
                render: (text, record) =>{
                    let title=text;
                    return (<div style={{display:'flex'}} title={'text'}>
                        <div>
                            <img src={record.icon} style={{width:'24px',height:'24px',objectFit: "contain"}}/>
                        </div>
                        <div>
                            <div
                                title={title}
                                style={{ color: "rgba(0, 0, 0, 0.85)",
                                    width:580,overflow:'hidden',whiteSpace:'nowrap',
                                    textOverflow:'ellipsis',
                                    fontSize: "16px",marginLeft:'8px'}}>{text}</div>
                        </div>
                    </div>)
                }
            },
            {
                title: '下载时间',
                dataIndex: 'createTime',
                width:300,
                render: (text, record) => {
                    return (<div>{formatTime(text)}</div>)
                }
            },
            {
                title: '大小',
                dataIndex: 'size',
                width:100,
                render: (text, record) => {
                    return (<div>{text>0?changeSize(text):0+'b'}</div>)
                }
            },
            {
                title: '操作',
                align:'center',
                dataIndex: 'address',
                width:200,
                render: (text, record) =>{
                 let size =record.size;
                    let newSecondSelectColor =this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3")
                    return (<div>{size>0?<span style={{cursor:"pointer",color:newSecondSelectColor}} onClick={()=>{
                            this.downLoad(record)
                        }}>下载</span>:<span style={{color:'rgba(0, 0, 0, 0.45)'}}>压缩中,请稍后刷新</span>}</div>


                   )
                }},
        ];
        return(
            <PageTableComponent columns={columns}

                                rowSelection={null}
                                data={this.state.data}
                                page={this.state.page}
                                size={this.state.size}
                                count={this.state.count}
                                onChangePage={(page, size)=>{
                                    this.onChangePage(page, size)
                                }}
            ></PageTableComponent>
        )
    }
    //全部清除
    allDelete(){
        confirm({
            title: '确定要清空下载记录？',
            onOk:()=> {
                this.request({
                    url: "/cm-sites-storage-management/zykDownLoad/emptyZykDownLoadList",
                    method: "get",
                    callBack: (data) => {
                        if(data){
                            this.getList()
                        }
                    }
                });
            },
            onCancel() {
            },
        });

    }
    //刷新
    getRefreshList(){
        this.request({
            url: "/cm-sites-storage-management/zykDownLoad/refreshList ",
            method: "get",
            callBack: (data) => {
                    this.getList()
            }
        });
    }
    //下载
    downLoad(record){
        this.request({
            url: "/cm-sites-storage-management/zykDownLoad/addZykDownLoad",
            method: "post",
            body:{virtualFileId:record.virtualFileId,name:record.name, downloadFlag:true},
            contentType:'json',
            callBack: (data) => {
                if(record.suffix=='zip') {
                    this.request({
                        url:'/cm-sites-storage-management/zykStatistics/addBatchDownloadData',
                        method: "get",
                        body:{zipId:record.virtualFileId},
                    })
                }else {
                    let fileType = '';
                    if(PIC_TYPE.indexOf(record.suffix)>-1) {
                        fileType = 1;
                    }else if(VIDEO_TYPE.indexOf(record.suffix)>-1){
                        fileType = 2;
                    }else if(AUDIO_TYPE.indexOf(record.suffix)>-1){
                        fileType = 3;
                    }else {
                        fileType = 4;
                    }
                    let body = {
                        id:record.virtualFileId,
                        fileName:record.name,   //String 文件名称
                        fileIcon:record.icon,   //String 文件显示缩略图
                        type:fileType,        //Integer 文件类型 参考前面保持一致
                        md5:record.md5,         //String 文件的md5
                        size:record.size,        //long  文件大小
                    }
                    this.request({
                        url: "/cm-sites-storage-management/zykStatistics/addDownloadRecords",
                        method: "post",
                        body:body,
                        contentType:'json',
                    })
                }
                if(data){
                    let url =  "/storage/downloadFile?md5="+record.md5+'&name='+record.name+'&download=1';
                    let aObj = document.createElement('a');
                    aObj.setAttribute('download','');
                    aObj.setAttribute('href',url);
                    aObj.click();
                    aObj = null
                }
            }
        });
    }
    onChangePage(page, size) {
        this.setState({page: page, size: size}, () => {
            this.getList()
        })
    }

    getList() {
        window.loading.show(true);
       let parms={};
        if (this.state.selectType.length) {
            parms.suffix = this.state.selectType
        }
        if (this.state.searchText) {
            parms.name = this.state.searchText
        }
        this.request({
            url: "/cm-sites-storage-management/zykDownLoad/downLoadPageList?page="+this.state.page+'&size='+this.state.size,
            method: "post",
            body: parms,
            contentType: "json",
            callBack: (data) => {
                window.loading.hide();
              this.setState({count:data.count,data:data.data},()=>{
                  $('.ant-pagination-options-quick-jumper').find('input').val('')
              })
            }
        });

    };













}